import React, { useEffect, useState } from 'react';
import { Link, Routes, Route } from 'react-router-dom';
import envConstants from "../Constants";
import axios from "../Axiosapi";
import FolderDetails from './folderdetails';  // Import FolderDetails

// Function to classify URLs into different categories based on the response structure
const classifyUrls = (data) => {
    const folderStructure = {
        product: [],
        category: [],
        brand: [],
        child_category: [],
        blogs: [],
        other: []  // For URLs that don't match any of the folders
    };

    // Loop through the response data and classify URLs into appropriate categories
    if (data.Product) {
        data.Product.forEach(item => folderStructure.product.push({ loc: item.url, lastmod: item.lastModified }));
    }
    if (data.Category) {
        data.Category.forEach(item => folderStructure.category.push({ loc: item.url, lastmod: item.lastModified }));
    }
    if (data['Child Categories']) {
        data['Child Categories'].forEach(item => folderStructure.child_category.push({ loc: item.url, lastmod: item.lastModified }));
    }
    if (data.Brand) {
        data.Brand.forEach(item => folderStructure.brand.push({ loc: item.url, lastmod: item.lastModified }));
    }
    if (data.Blogs) {
        data.Blogs.forEach(item => folderStructure.blogs.push({ loc: item.url, lastmod: item.lastModified }));  // Fixed: Use 'blog' instead of 'Blogs'
    }
    if (data['Other Pages']) {
        data['Other Pages'].forEach(item => folderStructure.other.push({ loc: item.url, lastmod: item.lastModified }));
    }

    return folderStructure;
};

const SiteMap = () => {
    const [urls, setUrls] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [folderStructure, setFolderStructure] = useState({});

    useEffect(() => {
        const fetchSitemap = async () => {
            try {
                const response = await axios.get(`${envConstants.API_BASE_URL}/sitemap-map`);  // API call to fetch sitemap data
                const data = response.data;  // Assuming the response is structured as shown (Product, Category, etc.)

                // Classify the URLs into folders based on the API response
                const classified = classifyUrls(data);
                setUrls(classified);  // Set the classified URLs
                setFolderStructure(classified);  // Set the folder structure for further use
            } catch (error) {
                setError(error);
                console.error(error);
            } finally {
                setLoading(false);
            }
        };

        fetchSitemap();  // Fetch sitemap data on component mount
    }, []);

    if (loading) {
        return <div className='container p-4'>Loading sitemap...</div>;
    }

    if (error) {
        return <div className='container p-4 text-danger'>Error: {error.message}</div>;
    }

    return (
        <div className='container-fluid p-4'>
            <h1 className='mb-4' style={{ color: '#ed1c24', fontSize: '24px' }}>
                Sitemap
            </h1>

            <div className='row'>
                <div className='col-md-12'>
                    <div className='list-group'>
                        <Link to="/product-sitemap.xml" className='list-group-item list-group-item-action d-flex justify-content-between align-items-center'>
                            Product
                            <span className='badge bg-primary rounded-pill'>{folderStructure.product ? folderStructure.product.length : 0} URLs</span>
                        </Link>
                        <Link to="/category-sitemap.xml" className='list-group-item list-group-item-action d-flex justify-content-between align-items-center'>
                            Category
                            <span className='badge bg-primary rounded-pill'>{folderStructure.category ? folderStructure.category.length : 0} URLs</span>
                        </Link>
                        <Link to="/child-category-sitemap.xml" className='list-group-item list-group-item-action d-flex justify-content-between align-items-center'>
                            Child Category
                            <span className='badge bg-primary rounded-pill'>{folderStructure.child_category ? folderStructure.child_category.length : 0} URLs</span>
                        </Link>
                        <Link to="/brand-sitemap.xml" className='list-group-item list-group-item-action d-flex justify-content-between align-items-center'>
                            Brand
                            <span className='badge bg-primary rounded-pill'>{folderStructure.brand ? folderStructure.brand.length : 0} URLs</span>
                        </Link>
                        <Link to="/blogs-sitemap.xml" className='list-group-item list-group-item-action d-flex justify-content-between align-items-center'>
                            Blogs
                            <span className='badge bg-primary rounded-pill'>{folderStructure.blogs ? folderStructure.blogs.length : 0} URLs</span>
                        </Link>
                        <Link to="/other-sitemap.xml" className='list-group-item list-group-item-action d-flex justify-content-between align-items-center'>
                            Other Pages
                            <span className='badge bg-primary rounded-pill'>{folderStructure.other ? folderStructure.other.length : 0} URLs</span>
                        </Link>
                    </div>
                </div>
            </div>

            <Routes>
                <Route path="/:folderName.xml" element={<FolderDetails urls={folderStructure} />} />
            </Routes>
        </div>
    );
};

export default SiteMap;
